import api from "!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/mini-css-extract-plugin/dist/loader.js!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./mobileHeader.css";

var options = {"insert":"body"};

options.insert = "body";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};